import { buildLaunchDarklyFlagUsedHandler } from '@sentry/react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { getEnvVariable } from '~/dev/utils/getEnvVariable';

import { LD_ALL_USERS_CONTEXT } from './constants';
import { useExposeLDClient } from './useFlag';

// Exposes the LDClient to getFlag() for imperative non-React call sites
// (Redux thunks, permission checks). Must live inside LDProvider.
const LDClientBridge = () => {
  useExposeLDClient();
  return null;
};

export const FlagsProvider = ({ children }: React.PropsWithChildren) => (
  <LDProvider
    clientSideID={getEnvVariable('LAUNCHDARKLY_CLIENT_SIDE_ID')}
    context={LD_ALL_USERS_CONTEXT}
    options={{
      // Real-time streaming via WebSocket is disabled; flags are fetched once
      // at init and re-evaluated on the next page load. Saves a persistent
      // connection for an app where flag changes don't need to be instant.
      streaming: false,
      // Pairs with Sentry.launchDarklyIntegration() in src/index.tsx so any
      // flags evaluated on this page get attached as context on Sentry events.
      inspectors: [buildLaunchDarklyFlagUsedHandler()],
    }}
    reactOptions={{ useCamelCaseFlagKeys: false }}
  >
    <LDClientBridge />
    {children}
  </LDProvider>
);
